import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=template&id=55dcb4ea&scoped=true"
import script from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=style&index=0&id=55dcb4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcb4ea",
  null
  
)

export default component.exports